import React from "react";
import {useStyles} from "./PlaylistProgressBarStyles.css";

const PlaylistProgressBar = ({completed}) => {
  
  const classes = useStyles({completed});

  return (
    <div className={classes.containerStyles}>
      <div className={classes.fillerStyles}>
        <span className={classes.labelStyles}>{`${completed}%`}</span>
      </div>
    </div>
  );
};

export default PlaylistProgressBar;